import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { IoIosInformationCircleOutline as InfoIcon } from "react-icons/io";

const InSessionHeavyLosses = ({
  handleChange,
  configDetails,
  inSessHeavyLossMinSoft,
  inSessHeavyLossMinHard,
  inSessHeavyLossAvgSessSoft,
  inSessHeavyLossAvgSessHard,
  inSessHeavyLossMaxSoft,
  inSessHeavyLossMaxHard,
}) => {
  return (
    <div className="mt-3 ps-3 w-100 card-style">
      {/* Header */}
      <div className="d-flex justify-content-between w-100">
        <h4 className="w-50 fw-bold">
          In-Session Heavy Losses{" "}
          <Tippy
            theme="light"
            content="Protect players from losing heavily during a single session |

            Min (amount) - set a players min net loss before triggering an intervention |
            
            Avg - Set how many times higher a players max net loss can be above their average session net loss before triggering an intervention |
            
            Max (amount) - set a players max net loss before triggering an intervention"
            arrow={false}
          >
            <span>
              <InfoIcon
                size="14"
                color="var(--secondary-blue)"
                className=" position-absolute translate-middle-y"
              />
            </span>
          </Tippy>
        </h4>
      </div>

      {/* Minimum */}
      <div className="d-flex justify-content-between w-100 align-items-center my-1">
        <p className="mb-0">Minimum (minutes)</p>
        <div className="d-flex align-items-center w-50">
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossMinSoft"
              value={configDetails.inSessHeavyLossMinSoft}
              // defaultValue={inSessHeavyLossMinSoft}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossMinHard"
              value={configDetails.inSessHeavyLossMinHard}
              // defaultValue={inSessHeavyLossMinHard}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
        </div>
      </div>
      {/* Average Session Time Multiplier */}
      <div className="d-flex justify-content-between w-100 align-items-center my-1">
        <p style={{ marginBottom: "0" }} className="w-50">
          Average Session GGR Multiplier
        </p>
        <div className="d-flex align-items-center w-50">
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossAvgSessSoft"
              value={configDetails.inSessHeavyLossAvgSessSoft}
              // defaultValue={inSessHeavyLossAvgSessSoft}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossAvgSessHard"
              value={configDetails.inSessHeavyLossAvgSessHard}
              // defaultValue={inSessHeavyLossAvgSessHard}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
        </div>
      </div>

      {/* Maximum */}
      <div className="d-flex justify-content-between w-100 align-items-center mb-3">
        <p style={{ marginBottom: "0" }} className="w-50">
          Maximum (minutes)
        </p>
        <div className="d-flex align-items-center w-50">
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossMaxSoft"
              value={configDetails.inSessHeavyLossMaxSoft}
              // defaultValue={inSessHeavyLossMaxSoft}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="inSessHeavyLossMaxHard"
              value={configDetails.inSessHeavyLossMaxHard}
              // defaultValue={inSessHeavyLossMaxHard}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InSessionHeavyLosses;
